var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config && _vm.config.login)?_c('HookCustom',{attrs:{"componente":_vm.config.login},on:{"loginsuccess":_vm.getDatosUsuario}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }